<div
  class="tree-row"
  [class.is-leaf]="node.isLeaf"
  [class.is-parent]="!node.isLeaf"
  [class.is-expanded]="isExpanded"
  [class.is-focused]="isFocused"
  [attr.data-defect-id]="node.defect.defectId"
  [style.--tree-depth]="node.depth"
  role="treeitem"
  [attr.aria-level]="node.depth + 1"
  [attr.aria-expanded]="!node.isLeaf ? isExpanded : null"
  tabindex="0"
  (click)="onClick($event)"
  (focus)="onFocus()"
  (keydown.enter)="onClick($any($event))"
  (keydown.space)="onClick($any($event))">

  <span class="tree-chevron material-icons" aria-hidden="true">
    {{ !node.isLeaf ? (isExpanded ? 'expand_more' : 'chevron_right') : 'fiber_manual_record' }}
  </span>

  <span class="tree-code" aria-hidden="true">{{ node.defect.number }}</span>

  <span class="tree-title">
    <span class="tree-title-main">{{ title }}</span>
    <span *ngIf="subtitle" class="tree-title-sub">{{ subtitle }}</span>
  </span>

  <span class="tree-meta">
    <span *ngIf="severity" class="severity-dot" [class]="'severity-' + severity" [attr.title]="severity">
      <span class="material-icons">
        {{ severity === 'critical' ? 'priority_high' : severity === 'major' ? 'warning' : 'report' }}
      </span>
    </span>

    <span *ngIf="!node.isLeaf" class="branch-badge" [attr.title]="node.defect.childCount + ' direct children'">
      {{ node.defect.childCount }}
    </span>
  </span>
</div>

<div *ngIf="!node.isLeaf && isExpanded" class="tree-children" role="group">
  <app-defect-admin-tree-node
    *ngFor="let child of node.children; trackBy: trackByChild"
    [node]="child"
    [expandedIds]="expandedIds"
    [focusedId]="focusedId"
    (nodeClick)="bubbleClick($event)"
    (focusChange)="bubbleFocus($event)">
  </app-defect-admin-tree-node>
</div>
